import styled from 'styled-components';

export const CueButton = styled.button`
    position: absolute;
    ${props => {
        const layout = props.layout || {};
        let styles = '';
        if (layout.top !== undefined) styles += `top: ${typeof layout.top === 'string' ? layout.top : `${layout.top}px`}; `;
        if (layout.right !== undefined) styles += `right: ${typeof layout.right === 'string' ? layout.right : `${layout.right}px`}; `;
        if (layout.bottom !== undefined) styles += `bottom: ${typeof layout.bottom === 'string' ? layout.bottom : `${layout.bottom}px`}; `;
        if (layout.left !== undefined) styles += `left: ${typeof layout.left === 'string' ? layout.left : `${layout.left}px`}; `;
        if (layout.width !== undefined) styles += `width: ${typeof layout.width === 'string' ? layout.width : `${layout.width}px`}; `;
        if (layout.height !== undefined) styles += `height: ${typeof layout.height === 'string' ? layout.height : `${layout.height}px`}; `;
        if (layout.transform) styles += `transform: ${layout.transform}; `;
        return styles;
    }}
    z-index: 10;
    border-radius: 50%;
    background: radial-gradient(circle at 30% 30%, #3a3a3a 0%, #1a1a1a 100%);
    border: 2px solid rgba(244, 212, 163, 0.3);
    box-shadow: 
        inset 0 2px 5px rgba(0, 0, 0, 0.5),
        0 2px 8px rgba(0, 0, 0, 0.3);
    color: rgba(244, 212, 163, 0.8);
    font-size: 0.7rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        border-color: rgba(244, 212, 163, 0.6);
        background: radial-gradient(circle at 30% 30%, #4a4a4a 0%, #2a2a2a 100%);
        box-shadow: 
            inset 0 2px 5px rgba(0, 0, 0, 0.5),
            0 2px 12px rgba(244, 212, 163, 0.4);
        transform: translateY(-2px);
    }

    &:active {
        transform: translateY(0);
        box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.7);
    }
`;

export const CueKeysContainer = styled.div`
    position: absolute;
    ${props => {
        const layout = props.layout || {};
        let styles = '';
        if (layout.top !== undefined) styles += `top: ${typeof layout.top === 'string' ? layout.top : `${layout.top}px`}; `;
        if (layout.right !== undefined) styles += `right: ${typeof layout.right === 'string' ? layout.right : `${layout.right}px`}; `;
        if (layout.bottom !== undefined) styles += `bottom: ${typeof layout.bottom === 'string' ? layout.bottom : `${layout.bottom}px`}; `;
        if (layout.left !== undefined) styles += `left: ${typeof layout.left === 'string' ? layout.left : `${layout.left}px`}; `;
        if (layout.width !== undefined) styles += `width: ${typeof layout.width === 'string' ? layout.width : `${layout.width}px`}; `;
        if (layout.height !== undefined) styles += `height: ${typeof layout.height === 'string' ? layout.height : `${layout.height}px`}; `;
        if (layout.transform) styles += `transform: ${layout.transform}; `;
        return styles;
    }}
    display: flex;
    flex-direction: row;
    gap: 10px;
    width: auto;
    height: auto;
    z-index: 10;
`;

export const CueKey = styled.button`
    ${props => {
        const layout = props.layout || {};
        let styles = '';
        if (layout.width !== undefined) styles += `width: ${typeof layout.width === 'string' ? layout.width : `${layout.width}px`}; `;
        if (layout.height !== undefined) styles += `height: ${typeof layout.height === 'string' ? layout.height : `${layout.height}px`}; `;
        return styles;
    }}

    background: #1a1a1a;
    border: 2px solid ${props => props.borderColor || 'rgba(244, 212, 163, 0.3)'};
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;
    overflow: hidden;

    &:hover {
        background: ${props => props.hoverColor || 'rgba(244, 212, 163, 0.1)'};
        border-color: ${props => props.borderColor || 'rgba(244, 212, 163, 0.6)'};
        transform: scale(1.05);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
    }

    &:active {
        transform: scale(0.95);
        background: ${props => props.activeColor || 'rgba(244, 212, 163, 0.2)'};
    }

    &::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 8px;
        height: 8px;
        background: ${props => props.borderColor || 'rgba(244, 212, 163, 0.5)'};
        border-radius: 50%;
        opacity: 0.6;
    }
`;

